































import Vue from 'vue'
export default Vue.extend({
    props: {
        //  The button displayed under the placeholder test (needs a 'callback' function to work)
        button: {
            type: Object,
            default: null
        },
        //  The color of the loading mask spinner
        color: {
            type: String,
            default: 'primary'
        },
        //  Heading above the placeholder img
        header: {
            type: String,
            default: null
        },
        //  The text displayed in the placeholder
        placeholder: {
            type: String,
            default: null
        },
        //  The icon used in place of an img
        icon: {
            type: String,
            default: null
        },
        //  The size of the icon placeholder
        iconSize: {
            type: String,
            default: '100px'
        },
        //  The img displayed in the placeholder
        img: {
            type: String,
            default: null
        },
        //  The styles for our image in the placeholder
        imgStyles: {
            type: Object,
            default: null
        },
        //  Replaces the img/icon with a inderminate process spinner
        indeterminate: {
            type: Boolean,
            default: false
        },
        //  Determines if the loading mask is shown
        loading: {
            type: Boolean,
            default: false
        },
        //  Determines if we put a set height on an image
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        filteredStyles(): object {
            //  Combine our height and styles prop
            return { ...this.height, ...this.imgStyles }
        },
        height(): object {
            if (this.small) return null
            return { height: `${this.$vuetify.breakpoint.xsOnly ? '150' : '200'}px` }
        }
    }
})
